import React from 'react';
import './GameBoy.css';

function GameBoy() {
  return (
    <div className="main-container">
      <h1>GameBoy</h1>
      <p>Tutorial para la GameBoy (en construccion jej)</p>
    </div>
  );
}

export default GameBoy;
